import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';

type StoredValue = string | null;

export type StorefrontOptionsResponse = {
  value: StoredValue;
  published_at: string | null;
  dirty: boolean;
};

export type StorefrontOptionsEnvelope = {
  value: string;
};

export interface StorefrontOptionsApiContract {
  get(siteId: string, siteEnv: string): Promise<StorefrontOptionsResponse>;
  update(siteId: string, siteEnv: string, envelope: StorefrontOptionsEnvelope): Promise<void>;
  publish(siteId: string, siteEnv: string): Promise<void>;
  delete(siteId: string, siteEnv: string): Promise<void>;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    storefrontOptions: StorefrontOptionsApiContract;
  }
}

export class StorefrontOptionsApi extends ApiService implements StorefrontOptionsApiContract {
  public get(siteId: string, siteEnv: string): Promise<StorefrontOptionsResponse> {
    return this.api.fetch<StorefrontOptionsResponse>({
      method: 'GET',
      path: this.path(siteId, siteEnv),
    });
  }

  public update(
    siteId: string,
    siteEnv: string,
    envelope: StorefrontOptionsEnvelope,
  ): Promise<void> {
    return this.api.fetch<void>({
      method: 'PUT',
      path: this.path(siteId, siteEnv),
      payload: envelope,
    });
  }

  public publish(siteId: string, siteEnv: string): Promise<void> {
    return this.api.fetch<void>({
      method: 'POST',
      path: `${this.path(siteId, siteEnv)}/publish`,
    });
  }

  public delete(siteId: string, siteEnv: string): Promise<void> {
    return this.api.fetch<void>({
      method: 'DELETE',
      path: this.path(siteId, siteEnv),
    });
  }

  private path(siteId: string, siteEnv: string): string {
    return `/${encodeURIComponent(siteId)}/${encodeURIComponent(siteEnv)}/spark-options`;
  }
}
